export enum DialogPosition {
    Left = "left",
    Right = "right",
    Top = "top",
    Bottom = "bottom",
    Center = "center",
}